/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestStartedNotificationAction } from './FanRemixContestStartedNotificationAction';
import {
    FanRemixContestStartedNotificationActionFromJSON,
    FanRemixContestStartedNotificationActionFromJSONTyped,
    FanRemixContestStartedNotificationActionToJSON,
} from './FanRemixContestStartedNotificationAction';

/**
 * 
 * @export
 * @interface FanRemixContestStartedNotification
 */
export interface FanRemixContestStartedNotification {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestStartedNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestStartedNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FanRemixContestStartedNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestStartedNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FanRemixContestStartedNotificationAction>}
     * @memberof FanRemixContestStartedNotification
     */
    actions: Array<FanRemixContestStartedNotificationAction>;
}

/**
 * Check if a given object implements the FanRemixContestStartedNotification interface.
 */
export function instanceOfFanRemixContestStartedNotification(value: object): value is FanRemixContestStartedNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FanRemixContestStartedNotificationFromJSON(json: any): FanRemixContestStartedNotification {
    return FanRemixContestStartedNotificationFromJSONTyped(json, false);
}

export function FanRemixContestStartedNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestStartedNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FanRemixContestStartedNotificationActionFromJSON)),
    };
}

export function FanRemixContestStartedNotificationToJSON(value?: FanRemixContestStartedNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FanRemixContestStartedNotificationActionToJSON)),
    };
}

